export default {
      id: "arrow-down-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }